var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Watch } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { Subject } from '@/models/Subject';
import AlertCard from '@/components/alert-card/AlertCard';
import SubjectOverview from '@/components/subject-overview/SubjectOverview';
import SubjectOverviewNew from '@/components/subject-overview-new/SubjectOverviewNew';
import AbstractUrl from '@/support/AbstractUrl';
import SummaryFilters from '@/components/SummaryFilters/SummaryFilters';
import { UserSubjectStatusEnum } from '@/models/UserSubject';
import { debounce, isEmpty, omitBy } from 'lodash';
import ErrorHandler from '@/support/ErrorHandler';
import client from '@/support/Client';
import DownloadOverviewDialog from '@/components/DownloadOverviewDialog/DownloadOverviewDialog';
import { Label } from '@/models/Label';
import SummaryLegendLabels from './SummaryLegendLabels/SummaryLegendLabels';
import { Group } from '@/models/Group';
let Summary = class Summary extends AbstractUrl {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Schedule Subject';
        this.topic = null;
        this.isIntializing = true;
        this.filters = {
            area: '',
            topic: '',
            groups: [],
            periods: [],
            levels: [],
            statuses: [
                UserSubjectStatusEnum.HIGHLIGHTED,
                UserSubjectStatusEnum.BUSY,
                UserSubjectStatusEnum.OLD,
                UserSubjectStatusEnum.CLOSED,
                UserSubjectStatusEnum.FINISHED
            ],
            updated_at: [],
            trashed: false,
            projects: [],
            exclude_projects: [],
        };
        this.isShowingLegendDialog = false;
        this.debounceFetchLabels = debounce(this.fetchLabels, 100);
        this.debounceFetchTopic = debounce(this.fetchTopic, 100);
        this.isDownloadingOverview = false;
        this.isDisplayingDownloadDialog = false;
        this.downloadOverviewUrl = '';
        this.labels = {};
        this.defaultGoalsetFilter = 'goalset-only';
    }
    mounted() {
        this.filters = { ...this.filters, ...this.$route.query };
        if (typeof this.filters.levels === 'string') {
            this.filters.levels = [this.filters.levels];
        }
        if (this.$route.query.goalset) {
            const value = this.$route.query.goalset;
            if (value === 'goalset-only') {
                if (this.group.projects) {
                    this.filters.projects = this.group.projects.map((project) => project.id || '');
                    this.defaultGoalsetFilter = 'goalset-only';
                }
            }
            else {
                this.filters.projects = [];
                this.defaultGoalsetFilter = 'all-goals';
            }
        }
        this.debounceFetchLabels();
        this.debounceFetchTopic();
        this.$nextTick(() => {
            this.isIntializing = false;
        });
    }
    onUpdateFilters() {
        const parsed = omitBy(this.filters, (value) => {
            return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);
        });
        this.setQueryParams(parsed);
    }
    async fetchTopic() {
        if (this.filters.topic) {
            this.topic = await new Subject().find(this.filters.topic);
        }
    }
    get breadcrumbs() {
        return [
            { name: this.$t('summary.title').toString(), path: '/subjects' },
        ];
    }
    get subjectOverviewComponent() {
        return (this.$refs && this.$refs.subjectOverviewComponent) || null;
    }
    onGoalsetFilterChanged(value) {
        if (value === 'goalset-only') {
            if (this.group.projects) {
                this.filters.projects = this.group.projects.map((project) => project.id || '');
                this.defaultGoalsetFilter = 'goalset-only';
            }
        }
        else {
            this.filters.projects = [];
            this.defaultGoalsetFilter = 'all-goals';
        }
    }
    async onClickDownloadOverview() {
        this.isDownloadingOverview = true;
        try {
            const parsed = omitBy(this.filters, isEmpty);
            const download = await client('get', 'subjects/export-summary', { filters: parsed, ...{ with: ['parent'] } });
            this.isDisplayingDownloadDialog = true;
            this.downloadOverviewUrl = download.data.pdf;
            // window.open(download.data.pdf, '_blank');
        }
        catch (error) {
            if (error.response) {
                ErrorHandler.network(error);
            }
        }
        finally {
            this.isDownloadingOverview = false;
        }
    }
    async fetchLabels() {
        try {
            const labels = await new Label()
                .limit(999)
                .all();
            this.labels = labels.reduce((accumulator, currentLabel) => {
                const { key, value } = currentLabel;
                if (key) {
                    accumulator[key] = value || '';
                }
                return accumulator;
            }, {});
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    onFiltersChanged(newValue, oldValue) {
        if (this.isIntializing) {
            return;
        }
        this.onUpdateFilters();
        this.debounceFetchLabels();
        this.debounceFetchTopic();
    }
};
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], Summary.prototype, "showFilters", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], Summary.prototype, "group", void 0);
__decorate([
    Watch('filters', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Summary.prototype, "onFiltersChanged", null);
Summary = __decorate([
    Component({
        components: {
            AlertCard,
            PageHeader,
            SummaryFilters,
            SubjectOverview,
            SubjectOverviewNew,
            DownloadOverviewDialog,
            SummaryLegendLabels,
        },
    })
], Summary);
export default Summary;
